/**
 * TanStack Query hooks for `react-native-sdk`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	reactNativeSdkQueryKeys,
	type CreateReactNativeSdkBody,
	type ListReactNativeSdkResponse,
	type ReactNativeSdkRow,
} from "./api";

export function useReactNativeSdkList(): UseQueryResult<ListReactNativeSdkResponse, Error> {
	return useQuery({
		queryKey: reactNativeSdkQueryKeys.list(),
		queryFn: list,
	});
}

export function useReactNativeSdkCreate(): UseMutationResult<ReactNativeSdkRow, Error, CreateReactNativeSdkBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reactNativeSdkQueryKeys.all });
		},
	});
}

export function useReactNativeSdkDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reactNativeSdkQueryKeys.all });
		},
	});
}
